import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CareplanHistoryDetailsComponent } from './careplan-history-details.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule, AngularEditorModule, FormsModule],
  declarations: [CareplanHistoryDetailsComponent],
  exports: [CareplanHistoryDetailsComponent]
})
export class CareplanHistoryDetailsModule { }
